import React from 'react'
import { Redirect, withRouter, RouteComponentProps } from 'react-router'
import { isAuthorizedPath } from 'domain/router/routes'
import { REDIRECT_URL_KEY } from 'lib/storage'

type Props = RouteComponentProps & { to?: string }

const RememberAndRedirect = withRouter(({ location, to = '/' }: Props) => {
  const uri = location.pathname + location.search + location.hash

  if (isAuthorizedPath(uri)) {
    window.localStorage.setItem(REDIRECT_URL_KEY, uri)
  }

  return <Redirect to={to} />
})

export default RememberAndRedirect
